module.exports = __webpack_public_path__ + "static/media/circle-ci-logo-mobile.132794b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/circle-ci-logo-mobile.png
// module id = 68
// module chunks = 0